<script lang="ts" setup>
const props = defineProps<{
  data: {
    id: string
    items: {
      block_vertical_slider_item_id: {
        id: string
        indicator: string
        image: string
        translations: DirectusTranslation<{
          title: string
          description: string
        }>
      }
    }[]
  }
}>()

const { dt } = useDirectusTranslation()

const slides = computed(() => props.data.items.map((item) => {
  return {
    id: item.block_vertical_slider_item_id.id,
    indicator: item.block_vertical_slider_item_id.indicator,
    image: item.block_vertical_slider_item_id.image,
    title: dt(item.block_vertical_slider_item_id.translations)?.title ?? '',
    description: dt(item.block_vertical_slider_item_id.translations)?.description ?? '',
  }
}))

const activeSlide = ref(0)
</script>

<template>
  <BlockBase class="py-6rem lg:py-12rem">
    <Container class="grid lg:grid-cols-[1fr_4fr_1fr]">
      <div />
      <div class="flex flex-col">
        <BlockVerticalSliderItem v-for="slide, index in slides" :key="slide.id" :data="slide" @activated="activeSlide = index" />
      </div>

      <div class="hidden h-full lg:block">
        <div class="sticky top-1/2 flex justify-end">
          <div class="w-3.5rem flex flex-col gap-1rem pb-6rem">
            <div
              v-for="slide, index in slides" :key="slide.id"
              class="h-px w-2rem rounded bg-neutral-darkGray transition-all"
              :class="{
                'bg-neutral-white h-2px w-3.5rem': index === activeSlide,
              }"
            />
            <div class="origin-left-bottom rotate-90 text-1.1rem text-neutral-darkGray tracking-3px uppercase">
              scroll
            </div>
          </div>
        </div>
      </div>
    </Container>
  </BlockBase>
</template>

<style>

</style>
